import Api from "../..";
import { PublicTransmedRegistration } from "../../../dtos/transmed/process/registration/registration";
import { TransmedRegistrationValidateInput } from "../../../dtos/transmed/process/validation/registration";
import transform from "../../../service/transform";

export default class TransmedValidateRegistrationApi extends Api {
  constructor() {
    super("transmed/registration/validate/registration");
  }

  public async get(): Promise<PublicTransmedRegistration[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError(
        "OutputTransmedRegistrationPart entry list is not an array."
      );

    return await Promise.all(
      data.map(
        async (value) => await transform(PublicTransmedRegistration)(value)
      )
    );
  }

  public async put(
    id: string,
    data: TransmedRegistrationValidateInput
  ): Promise<void> {
    await super.put(id, data);
  }
}
